import { Link } from "react-router-dom";
import ReactTyped from "react-typed";
import Layout from "./Layout";

const Admission = () => {
    return (
        <Layout>
            <div className="px-4 md:bg-[#f1f7ff]">
                {/* 
                <div className="flex md:mt-24 flex-col md:flex-row md:px-8">
<div className="md:w-3/4 px-4">
    <div className="max-w-lg">
        <h1 className="text-[#0a1a42] pb-4 mt-16 font-bold font-roboto text-4xl">Admission Area</h1>
        <h3 className="leading-8 text-[18px] font-roboto [#0a1a42]">
            At DRIC, our primary aim is to help our students identify their innate potential and skills, hone them, and help each child utilize them to positively affect their environment. Enrollment is fast and easy to navigate. Scroll through this page to see Admissions Criteria, otherwise, learn more About our school.
        </h3>
    </div>
    <div className="pt-4 space-x-2 pb-8">
        <button className="bg-[#f7951e] text-white px-6 py-3">About DRIC</button>
        <button className="border-2 border-[#f7951e] px-4 py-2">Curriculums Page</button>
    </div>
</div>
<div className="md:w-1/2 md:order-second md:mt-8">
    <img src="/schoolweb/admissionImage.webp"
        className="mx-auto md:mx-0 mb-4 md:mb-0"
        alt="" />
</div>
</div> 
*/}
                <div className=" md:mt-18 md:flex bg-[#f1f7ff] py-8 md:px-8 place-items-center justify-center">
                    <div className="md:w-2/4 ">
                        <ReactTyped
                            className="text-2xl text-[#0a1a42] mx-auto block pb-4 mt-16 font-bold font-roboto "
                            strings={['Start Your Journey With DRIC',
                                ' Apply for Admission']}
                            typeSpeed={40}
                        />
                        <h2>
                            We pride ourselves on the strength and quality of our educational
                            packages. Our Nigerian-British curriculum provides a trans-border
                            comparative and competitive advantage for our students, re-emphasizing
                            our mission to produce the total child in character and learning
                            through the provision of qualitative formal education combined with
                            the right Christian ethics and principles.
                        </h2>
                    </div>
                    <button className="text-white mx-auto block mt-8 bg-[#f7951e] px-8 py-2">
                        Download Admission Form
                    </button>
                </div>


                {/* 
                <div className="mt-12 md:mt-24 bg-[#dde4ed]">
                    <div class="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">

                        <Link href="#">
                            <h5 class="mb-2 text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">
                                Start Your Journey With DRIC
                                Apply for Admission
                            </h5>
                        </Link>
                        <p class="mb-3 font-normal text-gray-500 dark:text-gray-400">
                            We pride ourselves on the strength and quality of our educational packages. Our Nigerian-British curriculum provides a trans-border comparative and competitive advantage for our students, re-emphasizing our mission to produce the total child in character and learning through the provision of qualitative formal education combined with the right Christian ethics and principles.                        </p>
                        <Link href="#" class="inline-flex items-center text-blue-600 hover:underline">
                            Download Admission Form
                            <svg class="w-3 h-3 ml-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11v4.833A1.166 1.166 0 0 1 13.833 17H2.167A1.167 1.167 0 0 1 1 15.833V4.167A1.166 1.166 0 0 1 2.167 3h4.618m4.447-2H17v5.768M9.111 8.889l7.778-7.778" />
                            </svg>
                        </Link>
                    </div>
                </div> */}
                
                <div className="mt-8 md:mt-24 md:flex md:justify-center">

                    <div className="md:w-1/4">
                        <h1 className="font-roboto text-3xl text-[#0a1a42] mb-8 font-bold">
                            Fill Out The Form to Make Enquires
                        </h1>
                    </div>

                    <div>
                        <form className="space-y-8">
                            <span>
                                <input
                                    required
                                    type="text" placeholder="Full Name"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500  p-2.5 w-full"
                                />
                            </span>
                            <div className="flex space-x-4">
                                <span>
                                    <input
                                        required
                                        type="email"
                                        placeholder="Email"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500  p-2.5 "
                                    />
                                </span>
                                <span>
                                    <input
                                        required
                                        type="tel" placeholder="Phone Number"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500  p-2.5 " />
                                </span>
                            </div>

                            <div className="flex space-x-4 place-items-center">
                                <span>
                                    <select class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block  p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                                        <option selected>Select Grade of Choice</option>
                                        <option> Grade 7</option>
                                        <option> Grade 8</option>
                                        <option>Grade 9</option>
                                        <option>Grade 10</option>
                                        <option>Grade 11</option>
                                        <option>Grade 12</option>
                                    </select>
                                </span>

                                <span>
                                    <input type="number" placeholder="Age of Students" />
                                </span>
                            </div>

                            <div >
                                <textarea id="message" rows="4" class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300" placeholder="Write your thoughts here..."></textarea>
                            </div>

                            <button className="bg-[#f7951e] px-4 py-2 text-gray-100">
                                Submit Form
                            </button>
                        </form>
                    </div>

                </div>
            </div>
        </Layout>
    );
}

export default Admission;